// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__+yLIP","sidebar":"Dashboard_sidebar__5-D95","content":"Dashboard_content__83NEB","main":"Dashboard_main__7IG-F"};